import { render, staticRenderFns } from "./closeRecord.vue?vue&type=template&id=012aef8a"
import script from "./closeRecord.vue?vue&type=script&lang=js"
export * from "./closeRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports